module.exports = __webpack_public_path__ + "../front/img/468_høj_trådkurv+hylder+bøjestang.db9a081c.svg";